import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';
import { Events } from '../../utils/dom/html-events';
import { throttle } from 'lodash-es';

const EVENT_KEY_COUNTER = `.lta.textareacounter`;
const EVENT_KEYUP_COUNTER = `keyup.${EVENT_KEY_COUNTER}`;
class InputField extends FormComponent {
	init(questionData) {
		this.renderInputField(questionData);
	}
	markup(value, data = {}, titleMarkup) {
		this.inputFieldContainerClass = `lta-input-field-container-${data.id}`;
		this.inputID = `lta-input-field-id-${data.id}`;
		const placeholderText = data.placeHolder || '';
		const inputValue = data.value || '';
		const inputType = data.type || 'text';
		const inputName = `lta-input-field-name-${data.id}`;
		this.hasCounter = data.hasOwnProperty('hasCounter') ? data?.hasCounter : true;
		return `<div class="lta-input-field">
					<div class="lta-input-field-title">${titleMarkup}</div>
					<div class="lta-text-input__wrapper ${this.inputFieldContainerClass}">
						${this.renderInstructionLabel(data.instructionText)}
						${this.renderLabel(this.inputID)}
						<div class="lta-text-input--error"></div>
						${
							data?.isTextArea
								? `
								<textarea 
									type="${inputType}"
									class="lta-text-input u-mb-1" 
									id="${this.inputID}"
									name="${inputName}" 
									placeholder="${placeholderText}"
									rows="${data.rows || ''}"
									maxlength="${data?.maxlength}"
									minlength="${data?.minlength}"
									>${inputValue.length > 0 ? inputValue : ''}</textarea>
								`
								: `
								<input 
									type="${inputType}"
									class="lta-text-input u-mb-3" 
									id="${this.inputID}"
									name="${inputName}" 
									placeholder="${placeholderText}"
									value="${inputValue}" 
								/>
								`
						}
						${
							data?.isTextArea && this.hasCounter
								? `<div class="lta-text-input__counter u-mb-3 u-text-left">
										<span id="textarea-counter__current">${data?.maxlength ? data.maxlength : data.charLimit}</span> characters remaining
										<span class="u-hidden" id="textarea-counter__maximum">${data?.maxlength ? data.maxlength : data.charLimit}</span>
									</div>`
								: ``
						}
					</div>
				</div>`;
	}

	renderLabel(inputID) {
		return this.data.titlePattern
			? ``
			: `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">${this.data.label}</label>`;
	}

	renderInstructionLabel(instructionLabel) {
		return instructionLabel
			? `<div class="u-mb-2"><span class="lta-text-input__label-instruction">${instructionLabel}</span></div>`
			: '';
	}

	afterRender() {
		this.componentElement = SelectorEngine.findOne('.lta-input-field', this._element);
		this.inputFieldContainerElement = SelectorEngine.findOne(`.${this.inputFieldContainerClass}`, this._element);
		this.inputFieldElement = SelectorEngine.findOne(`#${this.inputID}`, this.inputFieldContainerElement);

		if (this.data?.value) {
			setTimeout(() => {
				this.handleInput();
			}, 100);
		}

		const textareaEl = SelectorEngine.findOne('textarea', this._element);

		this.counterContentUpdate();

		EventHandler.on(
			textareaEl,
			EVENT_KEYUP_COUNTER,
			throttle(() => {
				this.counterContentUpdate();
			}, 200)
		);

		EventHandler.on(this.inputFieldElement, Events.Blur, () => {
			this.handleInput();
		});
	}

	counterContentUpdate() {
		if (!this.hasCounter) {
			return;
		}
		const limit = this.data?.maxlength ? this.data?.maxlength : this.data?.minlength;

		const textareaEl = SelectorEngine.findOne('textarea', this._element);
		const currentValueEl = SelectorEngine.findOne('#textarea-counter__current', this._element);

		if (textareaEl?.value?.length >= 0) {
			if (this.data?.maxlength === (null || undefined || '') || !this.data?.maxlength) {
				if (limit - textareaEl.value.length >= 0) {
					currentValueEl.textContent = limit - textareaEl.value.length;
				} else {
					currentValueEl.textContent = 0;
				}
			} else {
				currentValueEl.textContent = limit - textareaEl.value.length;
			}
		}
	}

	handleInput() {
		this.inputValue = this.inputFieldElement.value;
		this.validate();

		if (this.inputValue) {
			this.value = { ...this.data, value: this.inputValue };
		}
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}

	validate() {
		const formElementData = {
			...(this.data?.hasLimit && {
				hasLimit: this.data?.hasLimit,
				charLimit: this.data?.charLimit
			}),
			...(this.data?.hasMaxLimit && {
				hasMaxLimit: this.data?.hasMaxLimit,
				maxCharLimit: this.data?.maxCharLimit
			}),
			type: this.data?.type,
			element: this.inputFieldContainerElement,
			formElement: this.inputFieldElement,
			errorMessage: this.data.errorMessage,
			isTextArea: this.data.isTextArea,
			minLength: this.data.minlength,
			minLengthErrorMessage: this.data.minLengthErrorMessage,
			maxCharErrorMessage: this.data.maxCharErrorMessage,
			allowNumbersOrSpecialCharacters: this.data?.allowNumbersOrSpecialCharacters,
			invalidErrorMessage: this.data?.invalidErrorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};

		return this.data?.isOptional ? true : validFormElementValue(this.inputValue, formElementData);
	}
}
export default InputField;
